import { memo, useEffect, useRef } from "react";

const getBearing = (prev, next) => {
  if (!prev || !next) return 0;

  const lat1 = prev.lat * (Math.PI / 180);
  const lat2 = next.lat * (Math.PI / 180);
  const dLon = (next.long - prev.long) * (Math.PI / 180);

  const y = Math.sin(dLon) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
};

const BranchMarker = ({ branch, mapRef }) => {
  const markerRef = useRef(null);
  const imgRef = useRef(null);

  const shouldShowMarker =
    branch?.orders?.some((o) => ["1", "2"].includes(o.status)) ?? false;

  useEffect(() => {
    if (!mapRef?.current || !window.google?.maps?.marker?.AdvancedMarkerElement)
      return;

    if (!shouldShowMarker) {
      if (markerRef.current) {
        markerRef.current.map = null;
        markerRef.current = null;
        imgRef.current = null;
      }
      return;
    }

    if (!branch?.location?.lat || !branch?.location?.long) return;

    const lat = Number(branch.location.lat);
    const lng = Number(branch.location.long);

    if (!markerRef.current) {
      const img = document.createElement("img");
      img.style.width = "55px";
      img.style.transition = "transform .25s linear";
      img.style.willChange = "transform";
      img.src = `${process.env.REACT_APP_PUBLIC_URL}assets/markers/active_branch_marker.png`;

      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        position: { lat, lng },
        content: img,
        map: mapRef.current,
        title: "Branch",
      });

      markerRef.current = marker;
      imgRef.current = img;
    } else {
      markerRef.current.position = { lat, lng };
      markerRef.current.map = mapRef.current;
    }

    if (branch.prevLocation && imgRef.current) {
      const angle = getBearing(branch.prevLocation, branch.location);
      imgRef.current.style.transform = `rotate(${angle}deg)`;
    }
  }, [branch, mapRef, shouldShowMarker]);

  return null;
};

export default memo(BranchMarker);
